import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AffAuthFrame } from "../../components/affiliate/AffAuthFrame";
import { affApi, affToken } from "../../lib/affApi";
import { fmtErr } from "../../lib/api";

export default function AffiliateVerify() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const [otp, setOtp] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [resent, setResent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      const { data } = await affApi.post("/affiliate/verify-otp", { email, otp });
      affToken.set(data.access_token);
      nav("/affiliate/dashboard?welcome=1", { replace: true });
    } catch (e2) { setErr(fmtErr(e2)); } finally { setBusy(false); }
  };
  const resend = async () => {
    try { await affApi.post("/affiliate/resend-otp", { email }); setResent(true); } catch (e2) { setErr(fmtErr(e2)); }
  };

  return (
    <AffAuthFrame title="Check your inbox" subtitle={`We sent a 6-digit code to ${email}.`} testId="aff-verify-page">
      <form onSubmit={submit} className="space-y-4" data-testid="aff-verify-form">
        <div><Label htmlFor="otp">Verification code</Label><Input id="otp" inputMode="numeric" maxLength={6} value={otp} onChange={(e) => setOtp(e.target.value)} required className="tracking-[0.4em] font-mono text-lg" data-testid="aff-verify-otp" /></div>
        {err && <div className="text-sm text-red-600" data-testid="aff-verify-error">{err}</div>}
        <Button type="submit" disabled={busy || otp.length < 6} className="w-full bg-ink hover:bg-black" data-testid="aff-verify-submit">{busy ? "Verifying…" : "Verify and open dashboard"}</Button>
        <button type="button" onClick={resend} className="w-full text-sm text-zinc-600 underline" data-testid="aff-verify-resend">{resent ? "Code sent again" : "Resend code"}</button>
      </form>
    </AffAuthFrame>
  );
}
